// Input validation utilities

export const validateEmail = (email) => {
  const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
  return emailRegex.test(email);
};

export const validatePhone = (phone) => {
  // Remove all non-digit characters
  const digitsOnly = phone.replace(/\D/g, '');
  
  // Check if it's exactly 10 digits
  return digitsOnly.length === 10;
};

export const formatPhoneNumber = (value) => {
  // Remove all non-digit characters (no spaces allowed)
  const digitsOnly = value.replace(/\D/g, '');
  
  // Limit to 10 digits (Indian phone numbers)
  return digitsOnly.slice(0, 10);
};

export const validatePhoneStrict = (phone) => {
  // Phone must be exactly 10 digits, no spaces or special characters
  const digitsOnly = phone.replace(/\D/g, '');
  return digitsOnly.length === 10 && phone === digitsOnly;
};

export const getPhoneDigits = (formattedPhone) => {
  // Extract only digits from formatted phone
  return formattedPhone.replace(/\D/g, '');
};

export const validateForm = (data, rules) => {
  const errors = {};
  
  Object.keys(rules).forEach(field => {
    const value = data[field];
    const rule = rules[field];
    
    // Required check
    if (rule.required && (!value || value.trim() === '')) {
      errors[field] = `${rule.label || field} is required`;
      return;
    }
    
    // Skip further validation if empty and not required
    if (!value || value.trim() === '') {
      return;
    }
    
    // Email validation
    if (rule.type === 'email' && !validateEmail(value)) {
      errors[field] = 'Please enter a valid email (e.g., abc@yourname.com)';
      return;
    }
    
    // Phone validation
    if (rule.type === 'phone' && !validatePhone(value)) {
      errors[field] = 'Please enter a valid 10-digit phone number';
      return;
    }
    
    // Min length
    if (rule.minLength && value.length < rule.minLength) {
      errors[field] = `${rule.label || field} must be at least ${rule.minLength} characters`;
      return;
    }
    
    // Max length
    if (rule.maxLength && value.length > rule.maxLength) {
      errors[field] = `${rule.label || field} must not exceed ${rule.maxLength} characters`;
      return;
    }
    
    // Pattern matching
    if (rule.pattern && !rule.pattern.test(value)) {
      errors[field] = rule.message || `${rule.label || field} format is invalid`;
      return;
    }
    
    // Custom validation
    if (rule.validate && typeof rule.validate === 'function') {
      const customError = rule.validate(value, data);
      if (customError) {
        errors[field] = customError;
      }
    }
  });
  
  return {
    isValid: Object.keys(errors).length === 0,
    errors
  };
};

// Example usage:
// const { isValid, errors } = validateForm(formData, {
//   email: { required: true, type: 'email', label: 'Email' },
//   phone: { required: true, type: 'phone', label: 'Phone Number' },
//   password: { required: true, minLength: 6, label: 'Password' }
// });
